import Swiper from "swiper";
import { Navigation, Controller } from "swiper/modules";
import { gsap } from "gsap";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

export default function initFullPageCarousel() {
  const container = document.querySelector(".full_page_carousel");
  if (!container) return;

  console.log("Full Page Carousel found, initializing standard version...");

  const mainSwiperEl = container.querySelector(".fpc_top_swiper");

  if (!mainSwiperEl) {
    console.error("Swiper element not found in Full Page Carousel");
    return;
  }

  // 1. Initialize Swiper
  const mainSwiper = new Swiper(mainSwiperEl, {
    modules: [Navigation],
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
